import { useEffect, useState } from "react";

const navLinks = [
  { href: "#daily", label: "今日速览" },
  { href: "#hot", label: "热议榜" },
  { href: "#channels", label: "分类盘点" },
  { href: "#recap", label: "全瓜复盘" },
  { href: "#reviews", label: "网友开麦" },
  { href: "#faq", label: "吃瓜FAQ" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
    setOpen(false);
  };

  return (
    <header className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${scrolled ? "bg-background-50/90 backdrop-blur-md border-b border-background-200" : "bg-transparent"}`}>
      <div className="mx-auto flex h-16 w-full max-w-7xl items-center justify-between px-4 md:px-6">
        <a href="#top" onClick={(e) => go(e, "#top")} className="flex items-center gap-2 cursor-pointer">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-chat-3-fill text-lg"></i>
          </span>
          <span className="serif-title text-xl font-bold text-foreground-900">
            吃瓜<span className="text-primary-600">今日</span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 md:flex">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={(e) => go(e, l.href)}
              className="rounded-full px-4 py-2 text-sm font-medium text-foreground-700 whitespace-nowrap hover:bg-background-200/70 hover:text-foreground-950 cursor-pointer"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#recap"
            onClick={(e) => go(e, "#recap")}
            className="hidden items-center gap-2 rounded-full bg-primary-500 px-5 py-2 text-sm font-semibold text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600 cursor-pointer sm:inline-flex"
          >
            <i className="ri-flashlight-line"></i>
            看今晚瓜田
          </a>
          <button
            onClick={() => setOpen(!open)}
            aria-label="展开菜单"
            className="flex h-10 w-10 items-center justify-center rounded-full text-foreground-800 hover:bg-background-200/70 cursor-pointer md:hidden"
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-3-line"} text-xl`}></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50/95 px-4 pb-4 pt-2 backdrop-blur-md md:hidden">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={(e) => go(e, l.href)}
              className="block rounded-lg px-3 py-3 text-sm font-medium text-foreground-800 hover:bg-background-100 cursor-pointer"
            >
              {l.label}
            </a>
          ))}
        </div>
      )}
    </header>
  );
}